const SELECTOR = 'results-list .product-grid';

function reorderSoldOutLast(grid) {
  if (!(grid instanceof HTMLElement)) return;

  const items = Array.from(grid.querySelectorAll(':scope > .product-grid__item[data-product-available]'));
  if (items.length < 2) return;

  const available = items.filter((item) => item.dataset.productAvailable === 'true');
  const soldOut = items.filter((item) => item.dataset.productAvailable !== 'true');
  const ordered = [...available, ...soldOut];

  const alreadyOrdered = items.every((item, index) => item === ordered[index]);
  if (alreadyOrdered) return;

  const fragment = document.createDocumentFragment();
  ordered.forEach((item) => fragment.appendChild(item));
  grid.appendChild(fragment);
}

function watchGrid(grid) {
  if (!(grid instanceof HTMLElement) || grid.dataset.soldOutLastReady === 'true') return;

  grid.dataset.soldOutLastReady = 'true';
  reorderSoldOutLast(grid);

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      reorderSoldOutLast(grid);
    });
  });

  observer.observe(grid, { childList: true });
}

function initializeSoldOutLast(root = document) {
  root.querySelectorAll?.(SELECTOR).forEach(watchGrid);
}

initializeSoldOutLast();

document.addEventListener('DOMContentLoaded', () => initializeSoldOutLast(), { once: true });

const pageObserver = new MutationObserver(() => initializeSoldOutLast());
pageObserver.observe(document.documentElement, { childList: true, subtree: true });
